/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectResponseDto } from '../../models/core-project-response-dto';

export interface ProjectsControllerFindByCode$Params {
  tenant: string;
  code: string;
}

export function projectsControllerFindByCode(http: HttpClient, rootUrl: string, params: ProjectsControllerFindByCode$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectsControllerFindByCode.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectResponseDto>;
    })
  );
}

projectsControllerFindByCode.PATH = '/o2-core/projects/{tenant}/by-code/{code}';
